export const PRODUCT_454_ID = 454;
export const DEFAULT_MAX_QUANTITY = 100;
export const DEFAULT_MIN_QUANTITY = 1;
export const DEFAULT_QUANTITY_STEP = 1;
export const PRODUCT_454_MIN_QUANTITY = 2;
export const PRODUCT_454_QUANTITY_STEP = 2;

export const getProductId = (productOrId) => {
  const raw = typeof productOrId === "object" ? productOrId?.id : productOrId;
  const num = Number(raw);
  return Number.isNaN(num) ? null : num;
};

export const isProduct454 = (productOrId) => getProductId(productOrId) === PRODUCT_454_ID;

export const getQuantityStep = (productOrId) =>
  isProduct454(productOrId) ? PRODUCT_454_QUANTITY_STEP : DEFAULT_QUANTITY_STEP;

export const getMinQuantity = (productOrId) =>
  isProduct454(productOrId) ? PRODUCT_454_MIN_QUANTITY : DEFAULT_MIN_QUANTITY;

export const getMaxQuantity = () => DEFAULT_MAX_QUANTITY;

export const getInitialAddQuantity = (productOrId) =>
  isProduct454(productOrId) ? PRODUCT_454_MIN_QUANTITY : DEFAULT_MIN_QUANTITY;

export const normalizeQuantity = (productOrId, quantity) => {
  let qty = Math.floor(Number(quantity)) || 0;
  if (qty <= 0) return 0;

  const maxQty = getMaxQuantity();

  if (isProduct454(productOrId)) {
    qty = Math.floor(qty / PRODUCT_454_QUANTITY_STEP) * PRODUCT_454_QUANTITY_STEP;
    if (qty < PRODUCT_454_MIN_QUANTITY) qty = PRODUCT_454_MIN_QUANTITY;
    if (qty > maxQty) qty = maxQty;
    return qty;
  }

  if (qty < DEFAULT_MIN_QUANTITY) qty = DEFAULT_MIN_QUANTITY;
  if (qty > maxQty) qty = maxQty;
  return qty;
};

export const applyQuantityChange = (productOrId, currentQuantity, increase) => {
  const current = Math.floor(Number(currentQuantity)) || 0;
  const step = getQuantityStep(productOrId);
  const minQty = getMinQuantity(productOrId);
  const maxQty = getMaxQuantity();

  if (current === 0) {
    return increase ? getInitialAddQuantity(productOrId) : 0;
  }

  if (increase) {
    const next = current + step;
    return next > maxQty ? current : next;
  }

  const next = current - step;
  return next < minQty ? 0 : next;
};

export const isIncreaseDisabled = (productOrId, currentQuantity) => {
  const current = Math.floor(Number(currentQuantity)) || 0;
  return current >= getMaxQuantity();
};

export const isDecreaseDisabled = (currentQuantity) => {
  const current = Math.floor(Number(currentQuantity)) || 0;
  return current <= 0;
};

export const getPvDeltaForNextIncrease = (productOrId, currentQuantity, unitPv = 0) => {
  const current = Math.floor(Number(currentQuantity)) || 0;
  const pv = unitPv ?? 0;

  if (isIncreaseDisabled(productOrId, current)) return 0;

  if (current === 0) {
    return pv * getInitialAddQuantity(productOrId);
  }

  return pv * getQuantityStep(productOrId);
};

export const normalizeCartItem = (item) => {
  if (!item) return null;
  const normalizedQty = normalizeQuantity(item.id, item.quantity);
  if (normalizedQty === 0) return null;
  return { ...item, quantity: normalizedQty };
};

export const normalizeCartItems = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => normalizeCartItem(item)).filter(Boolean);
};

export const computeCartTotalPv = (items) =>
  (items ?? []).reduce((total, product) => total + (product.pv ?? 0) * product.quantity, 0);

export const normalizeOrderPayload = (payload) => {
  if (!payload?.order_items) return payload;
  return {
    ...payload,
    order_items: normalizeCartItems(payload.order_items),
  };
};
